import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.7586 5.73204L14.268 2.24064C14.1519 2.12453 14.0141 2.03243 13.8624 1.9696C13.7107 1.90676 13.5482 1.87442 13.384 1.87442C13.2198 1.87442 13.0572 1.90676 12.9056 1.9696C12.7539 2.03243 12.6161 2.12453 12.5 2.24064L2.86641 11.875C2.74983 11.9907 2.65741 12.1283 2.59451 12.28C2.5316 12.4317 2.49948 12.5944 2.50001 12.7586V16.25C2.50001 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41849 17.5 3.75001 17.5H7.24141C7.40563 17.5005 7.5683 17.4684 7.71999 17.4055C7.87168 17.3426 8.00935 17.2502 8.12501 17.1336L17.7586 7.50001C17.8747 7.38394 17.9668 7.24612 18.0296 7.09445C18.0925 6.94277 18.1248 6.7802 18.1248 6.61603C18.1248 6.45185 18.0925 6.28928 18.0296 6.13761C17.9668 5.98593 17.8747 5.84812 17.7586 5.73204ZM7.24141 16.25H3.75001V12.7586L10.625 5.88361L14.1164 9.37501L7.24141 16.25ZM15 8.49064L11.5086 5.00001L13.3836 3.12501L16.875 6.61564L15 8.49064Z",
		fill: "#042914"
	})
});
export { SvgEdit as ReactComponent };
